module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 6
// module chunks = 0